import { Button, IconButton } from 'rsuite';
import { VerifiedIcon } from '@/widgets/components/verified-icon';
import styled, { css } from 'styled-components';

export const ListingSectionTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  color: #101938;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const ListingSectionTitleWrapper = styled.div`
  border-bottom: 2px solid rgba(8, 10, 37, 0.1);
  padding-bottom: 10px;
  gap: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
`;

export const NavButtonsWrapper = styled.div`
  display: flex;
  gap: 15px;
`;

export const buttonCss = css`
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  padding: 6px 10px;
`;

export const StyledButton = styled(Button)`
  ${buttonCss}
  color: ${(props) => (props.islivelisting === 0 ? '#101938' : '#37A3BC')};
`;

export const StyledIconButton = styled(IconButton)`
  ${buttonCss}
  color: ${(props) => (props.islivelisting === 0 ? '#101938' : '#37A3BC')};
`;

export const LiveNotLiveButton = styled(IconButton)`
  ${buttonCss}
  color: ${(props) => (props.islivelisting ? '#37A3BC' : 'rgba(0,0,0,0.85)')};
  width: 120px;
  font-weight: ${(props) => (props.islivelisting ? '600' : 'normal')};
`;

export const VerifiedListingIcon = styled(VerifiedIcon)`
  font-size: 20px;
  flex-shrink: 0;
`;
